import React from 'react';

const Gauge = ({ value }) => {
  const percentage = Math.min(Math.max(value, 0), 1) * 100;

  return (
    <div className="gauge">
      <div
        className="gauge-disc"
        style={{ left: `calc(${percentage}% - 10px)` }} // Center the disc
      ></div>
      <div
        className="gauge-label"
        style={{ left: `calc(${percentage}% - 10px)` }} // Align the label with the disc
      >
        {Number((value ?? 0).toFixed(2)).toLocaleString('fr-FR', { minimumFractionDigits: 2 })}
      </div>
    </div>
  );
};

export default Gauge;
